export default {
    baseUrl:"https://test-5511-4-1307606712.sh.run.tcloudbase.com"
    //baseUrl:"http://localhost:8080"
}